const Caption = {
  baseStyle: {
    color: 'wl-blue.navy',
  },
};

export default Caption;
